import { render, staticRenderFns } from "./PendingOrdersList.vue?vue&type=template&id=2c14ccfc&"
import script from "./PendingOrdersList.vue?vue&type=script&lang=js&"
export * from "./PendingOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./PendingOrdersList.vue?vue&type=style&index=0&id=2c14ccfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports